import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-manage-passenger-classes-dialog-list-item',
  templateUrl: './manage-passenger-classes-dialog-list-item.component.html',
  styleUrls: ['./manage-passenger-classes-dialog-list-item.component.scss']
})
export class ManagePassengerClassesDialogListItemComponent implements OnInit {

  @Input() item: any;
  @Input() opened = false;
  @Input() shallNotOpen = false;

  constructor() { }

  ngOnInit(): void {
  }

}
